module.exports = __webpack_public_path__ + "img/20191202173250229.71d6af6e.jpg";